/*
  KAF page transition
  ------------------------------------------------------------------
  2026-08-01 — in-app browser guard.

  Instagram / Facebook / TikTok / Snapchat open links inside an embedded
  webview rather than the system browser. In those webviews the scripted,
  delayed navigation used below (preventDefault -> 700ms -> location.href)
  could leave the visitor on a blank page, on top of Horizon's own
  cross-document view transitions. Inside those apps we now do nothing at
  all: links navigate natively and the overlay is removed from the DOM
  (a full-viewport backdrop-filter layer is expensive in a webview even at
  opacity 0).
*/
(function () {
  "use strict";

  var overlay = document.getElementById("kaf-page-transition");
  if (!overlay) return;
  if (document.documentElement.classList.contains("shopify-design-mode")) return;

  var IN_APP_BROWSER = /Instagram|FBAN|FBAV|FBIOS|FB_IAB|FB4A|Messenger|BytedanceWebview|musical_ly|TikTok|Snapchat|SnapchatWebview|Twitter|LinkedInApp|Pinterest|MicroMessenger|\bLine\//i;

  if (IN_APP_BROWSER.test(navigator.userAgent || "")) {
    if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    return;
  }

  function shouldSkip(link) {
    if (!link || !link.href) return true;
    if (link.target === "_blank") return true;
    if (link.getAttribute("href") === "#") return true;
    if (link.hasAttribute("download")) return true;

    var proto = link.protocol;
    if (proto === "mailto:" || proto === "tel:" || proto === "javascript:") return true;
    if (link.hostname !== window.location.hostname) return true;
    if (
      link.pathname === window.location.pathname &&
      link.search === window.location.search &&
      link.hash !== ""
    ) {
      return true;
    }
    if (link.href.indexOf("/checkout") !== -1) return true;
    if (overlay.classList.contains("kaf-transition--active")) return true;

    return false;
  }

  document.addEventListener(
    "click",
    function (e) {
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      var target = e.target;
      var link = target && target.closest ? target.closest("a") : null;
      if (shouldSkip(link)) return;

      e.preventDefault();
      var href = link.href;

      overlay.classList.add("kaf-transition--active");

      setTimeout(function () {
        window.location.href = href;
      }, 700);

      // Watchdog: never leave the visitor stranded behind the veil.
      setTimeout(function () {
        overlay.classList.remove("kaf-transition--active");
      }, 6000);
    },
    true
  );

  // Clear the veil on every restore, not only bfcache restores.
  window.addEventListener("pageshow", function () {
    overlay.classList.remove("kaf-transition--active");
  });

  window.addEventListener("beforeunload", function () {
    overlay.classList.add("kaf-transition--active");
  });
})();
